module.exports = __webpack_public_path__ + "static/media/elephant-modal.5d8924fd.gif";